<template>
  <div class="activities">
    <el-collapse v-model="openedActivities">
      <activity
        v-for="activity in activityArray"
        :activityData="activity"
        :key="activity.activityCVId"
        :is-active="isActivityActive(activity.activityCVId)"
        :is-current-user="isCurrentUser"
        :is-public-c-v="isPublicCV"
        :user-id="userId"
      />
    </el-collapse>
  </div>
</template>

<script>
import Activity from '@/components/profile/Activity.vue';
import {
  getActivityCVByUserId,
  getCurrentUserActivityCV,
} from '@/api/profile.js';

export default {
  name: 'Activities',
  components: {
    Activity,
  },
  props: {
    isCurrentUser: {
      type: Boolean,
      required: false,
    },
    isPublicCV: {
      type: Boolean,
      required: false,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      openedActivities: [],
      activityArray: [],
    };
  },
  computed: {},
  methods: {
    async fetchUserActivities() {
      const { isCurrentUser, userId } = this;
      const { data, success } = isCurrentUser
        ? await getCurrentUserActivityCV()
        : await getActivityCVByUserId({ userId });

      if (success) {
        this.activityArray = data.items;
      }
    },
    isActivityActive(activityId) {
      const { openedActivities } = this;

      if (openedActivities.length) {
        const isActivityActive = openedActivities.some(
          (activity) => activity === activityId,
        );
        return isActivityActive;
      }
      return false;
    },
  },
  created() {
    this.fetchUserActivities();
  },
  watch: {
    userId(newVal) {
      if (newVal) {
        this.fetchUserActivities();
      }
    },
  },
};
</script>
